/**
 * Google search links for pricing an item by hand.
 *
 * The app used to fetch Google Shopping prices through SerpAPI and serve them
 * as the AI price; they were accepted 4% of the time, so that was removed.
 * The salesperson now opens the search themselves. Mirrors
 * generateGoogleShoppingUrl in backend-node/src/services/marketResearch.js.
 */

/** Drop the "[SPEC: ...]" requirement block extraction appends to item names. */
export function stripSpecBlock(name: string | null | undefined): string {
  return String(name ?? "")
    .replace(/\s*\[SPEC:[^\]]*\]?/gi, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** Item name plus model number, unless the name already carries the model. */
export function buildSearchQuery(itemName: string | null | undefined, modelNumber?: string | null): string {
  const query = stripSpecBlock(itemName);
  const model = (modelNumber ?? "").trim();
  if (model && !query.toLowerCase().includes(model.toLowerCase())) {
    return `${query} ${model}`.trim();
  }
  return query;
}

/** Google Shopping, Singapore locale - shows prices next to products. */
export function googleShoppingUrl(itemName: string | null | undefined, modelNumber?: string | null): string {
  const params = new URLSearchParams({
    tbm: "shop",
    q: buildSearchQuery(itemName, modelNumber),
    gl: "sg",
    hl: "en",
    cr: "countrySG",
  });
  return `https://www.google.com/search?${params.toString()}`;
}
